import { CustomerType } from '@/entities/CustomerType';

export class UserHelper {
    // user is defined in _Layout.cshtml
    public static isAuthenticated(): boolean {
        return (window as any).formula.user.isAuthenticated;
    }

    public static isValidated(): boolean {
        const customerType: string = (window as any).formula.user.customerType;
        if (customerType) {
            return CustomerType[customerType as keyof typeof CustomerType] !== CustomerType.NotValidated;
        }
        return false;
    }

    public static hasDiscounts(): boolean {
        const customerType: string = (window as any).formula.user.customerType;
        if (customerType) {
            const ct = CustomerType[customerType as keyof typeof CustomerType];
            return ct === CustomerType.PrepaidWithDiscount || ct === CustomerType.NoPrepaidWithDiscount;
        }
        return false;
    }

    public static hasShippingCosts(): boolean {
        const customerType: string = (window as any).formula.user.customerType;
        if (customerType) {
            return CustomerType[customerType as keyof typeof CustomerType] !== CustomerType.NoPrepaidWithDiscount;
        }
        return false;
    }

    public static getCustomerType(): CustomerType {
        const customerType: string = (window as any).formula.user.customerType;
        return CustomerType[customerType as keyof typeof CustomerType];
    }
}
